import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Destroyer } from '@shared/utils';
import { SpinnerComponent } from './spinner.component';
import {
    Router,
    RouterEvent,
    ActivationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError,
} from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService extends Destroyer {
    overlayRef: OverlayRef;
    loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
        false
    );
    loader$ = this.loaderSubject.asObservable();

    constructor(private overlay: Overlay, private router: Router) {
        super();
    }

    public initRouterEventSpinner(): void {
        this.router.events
            .pipe(takeUntil(this.destroy$))
            .subscribe((event: RouterEvent) => this.checkRouterEvent(event));
    }

    private checkRouterEvent(routerEvent: RouterEvent): void {
        if (routerEvent instanceof ActivationStart) {
            this.start();
            return;
        }

        if (
            routerEvent instanceof NavigationEnd ||
            routerEvent instanceof NavigationCancel ||
            routerEvent instanceof NavigationError
        ) {
            this.stop();
        }
    }

    start(message?: string) {
        if (this.overlayRef || this.loaderSubject.getValue()) {
            return;
        }

        this.overlayRef = this.overlay.create({
            positionStrategy: this.overlay.position().global(),
            scrollStrategy: this.overlay.scrollStrategies.block(),
            hasBackdrop: true,
        });
        const ref = this.overlayRef.attach(
            new ComponentPortal(SpinnerComponent)
        );
        if (message) {
            ref.instance.message = message;
            ref.changeDetectorRef.detectChanges();
        }
        this.loaderSubject.next(true);
    }

    stop(): void {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = undefined;
        }
        this.loaderSubject.next(false);
    }

}
